export default "__VITE_ASSET__DLJKMY04__"